// Mirrors utils/adminAccess.js on the server, which is what actually
// enforces access. Used here only to show/hide screens and build forms.
export const ACCESS_LABELS = {
  place_outlet_order: "Place orders (Sales page)",
  manage_table_orders: "Table orders",
  view_orders_history: "View order history",
  update_order_status: "Update order status",
  edit_invoice_date: "Edit invoice date",
  create_food_item: "Create food items",
  edit_food_item_details: "Edit food item details",
  edit_food_item_quantity: "Edit food item quantity",
  edit_outlet_details: "Edit outlet details",
  view_customers: "View customers",
  manage_customers: "Add / edit customers",
  view_payments: "View payments",
  manage_payments: "Add / edit payments",
  view_expenses: "View expenses",
  manage_expenses: "Add / edit expenses",
};

export const ACCESS_FIELDS = Object.keys(ACCESS_LABELS);

export const emptyAccess = () =>
  Object.fromEntries(ACCESS_FIELDS.map((field) => [field, false]));

// Owners' access is fixed on the server (OWNER_ACCESS there): everything
// except taking orders. Their stored access is ignored by the server.
export const OWNER_ACCESS = Object.freeze(
  Object.fromEntries(
    ACCESS_FIELDS.map((field) => [
      field,
      field !== "place_outlet_order" && field !== "manage_table_orders",
    ])
  )
);

// The access the server actually enforces for an owner/admin record, as
// effectiveAccess() on the server does
export const effectiveAccess = (admin) =>
  admin?.adminType === "Owner"
    ? { ...OWNER_ACCESS }
    : Object.fromEntries(
        ACCESS_FIELDS.map((field) => [field, admin?.access?.[field] === true])
      );

export const isOwner = (userInfo) => userInfo?.adminType === "Owner";

export const isPrimaryOwner = (userInfo) =>
  isOwner(userInfo) && userInfo?.isPrimaryOwner === true;

// Admins (not owners) assigned to an outlet. Owners don't count towards the
// outlet's paid admin limit (outlet.numberOfAdmins, default 1), matching
// the server's check
export const outletAdminsOf = (admins, outletId) =>
  (Array.isArray(admins) ? admins : []).filter(
    (admin) =>
      admin?.adminType === "Admin" &&
      (admin.outletId || [])
        .map((id) => String(id?._id || id))
        .includes(String(outletId))
  );

export const outletAdminLimit = (outlet) =>
  Number(outlet?.numberOfAdmins) > 0 ? Number(outlet.numberOfAdmins) : 1;

// True when the logged-in owner/admin holds at least one of the fields.
export const canAccess = (userInfo, ...fields) =>
  fields.some((field) => userInfo?.access?.[field] === true);
